import { jsxs as c, jsx as o } from "react/jsx-runtime";
import { FileSourceEnum as E, FileSelectorModal as x, FileTypeEnum as g } from "@systemeio/file-manager";
import { Tooltip as F, toast as v } from "@systemeio/ui";
import { useEditorState as M } from "../../node_modules/@tiptap/react/dist/index.mjs";
import { useState as N, useMemo as C, Fragment as O } from "react";
import { ToolbarButton as b } from "../../components/content-controls/toolbar-button.mjs";
import { getToolbarIconClassName as p, TOOLTIP_STYLES as k } from "../../constants/default-styles.mjs";
import { ImageModeEnum as y } from "./image-enum.mjs";
import I from "../../icons/image-icon.mjs";
import { InsertImageViaLink as h } from "./insert-image-via-link.mjs";
import { useTranslation as B } from "../../i18n.mjs";
import { ImageBubbleMenu as L } from "./image-bubble-menu.mjs";
const G = (a, t) => {
  const { t: n } = B(), s = (t == null ? void 0 : t.fileSource) ?? E.TextEditor, [u, m] = N(!1), d = M({
    editor: a,
    selector: ({ editor: r }) => ({
      isEditable: (r == null ? void 0 : r.options.editable) ?? !1
    })
  }), e = !(d != null && d.isEditable);
  return C(() => {
    const r = (l) => {
      if (!a) return null;
      const f = () => a.chain().focus().run();
      if (!l) return f();
      const i = new Image();
      i.src = l, i.onerror = () => {
        v.error(n("image_error")), f();
      }, i.onload = () => {
        const S = i.naturalWidth, T = i.naturalHeight;
        a.chain().focus().setImage({
          src: l,
          imageMode: y.BlockCenter,
          containerWidth: "auto",
          width: S,
          height: T
        }).run(), m(!1);
      };
    };
    return {
      toolbarRender: /* @__PURE__ */ c("div", { className: "hover:divide-text-secondary/30 flex divide-x divide-transparent", children: [
        /* @__PURE__ */ o(F, { disabled: e, label: n("image"), ...k, children: /* @__PURE__ */ o(b, { disabled: e, onClick: () => m(!0), children: /* @__PURE__ */ o(I, { className: p(e) }) }) }),
        /* @__PURE__ */ o(h, { handleSetImage: r, isDisabled: e })
      ] }),
      tooltipRender: /* @__PURE__ */ c("div", { className: "flex", children: [
        /* @__PURE__ */ c(
          b,
          {
            className: "gap-1.5",
            disabled: e,
            onClick: () => m(!0),
            children: [
              /* @__PURE__ */ o(I, { className: p(e) }),
              n("image")
            ]
          }
        ),
        /* @__PURE__ */ o(h, { handleSetImage: r, isDisabled: e })
      ] }),
      additionalRender: /* @__PURE__ */ c(O, { children: [
        /* @__PURE__ */ o(
          x,
          {
            initialSearchFilters: {
              name: "",
              source: [s],
              type: [g.Image, g.ImageOther]
            },
            opened: u,
            onClose: () => m(!1),
            onSelect: ({ path: l }) => r(l),
            uploadingFromSource: s,
            disabledFileTypeSelect: !0
          }
        ),
        /* @__PURE__ */ o(L, { editor: a, fileSource: s, options: t })
      ] })
    };
  }, [e, u, a, s, t, n]);
};
export {
  G as useImageExtensionToolbar
};
